<template>
  <v-app>
    <v-content role="main">
      <the-side-nav role="navigation"></the-side-nav>
      <snackbar></snackbar>
      <loader></loader>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
      </transition>
    </v-content>
    <the-footer></the-footer>
    <back-to-top bottom="50px" right="50px">
      <button type="button" class="btn btn-info btn-to-top">
        <i class="fas fa-chevron-up"></i>
      </button>
    </back-to-top>
  </v-app>
</template>

<script>
import TheFooter from './components/TheFooter';
import TheSideNav from './components/TheSideNav';
import Snackbar from './components/Snackbar';
import Loader from './components/Loader';

export default {
  name: 'App',
  components: {
    TheFooter,
    TheSideNav,
    Snackbar,
    Loader,
  },
  metaInfo: {
    title: 'PR Properties Group',
    titleTemplate: '%s | PR Properties Group',
  },
};
</script>
